import { gql } from '@apollo/client';

// Query to get custom flags for a specific job
export const GET_CUSTOM_FLAGS_FOR_JOB = gql`
  query GetCustomFlagsForJob($jobId: ID!) {
    getCustomFlagsForJob(jobId: $jobId) {
      id
      jobId
      templateId
      template {
        id
        flagValue
        iconName
        backgroundColor
        textColor
      }
      flagType
      flagValue
      flagColor
      isManual
      addedByUserId
      addedByUser {
        id
        name
      }
      sortOrder
      createdAt
      updatedAt
    }
  }
`;

// Query to get available flag templates
export const GET_FLAG_TEMPLATES = gql`
  query GetFlagTemplates {
    getFlagTemplates
  }
`;

// Query to get values for a specific flag template
export const GET_FLAG_TEMPLATE_VALUES = gql`
  query GetFlagTemplateValues($templateType: String!) {
    getFlagTemplateValues(templateType: $templateType)
  }
`;

// Mutation to add a custom flag to a job
export const ADD_CUSTOM_JOB_FLAG = gql`
  mutation AddCustomJobFlag($input: AddCustomJobFlagInput!) {
    addCustomJobFlag(input: $input) {
      id
      jobId
      templateId
      template {
        id
        flagValue
        iconName
        backgroundColor
        textColor
      }
      flagType
      flagValue
      flagColor
      isManual
      addedByUserId
      addedByUser {
        id
        name
      }
      sortOrder
      createdAt
      updatedAt
    }
  }
`;

// Mutation to update a custom flag
export const UPDATE_CUSTOM_JOB_FLAG = gql`
  mutation UpdateCustomJobFlag($input: UpdateCustomJobFlagInput!) {
    updateCustomJobFlag(input: $input) {
      id
      jobId
      flagType
      flagValue
      flagColor
      isManual
      addedByUserId
      addedByUser {
        id
        name
      }
      sortOrder
      createdAt
      updatedAt
    }
  }
`;

// Mutation to remove a custom flag
export const REMOVE_CUSTOM_JOB_FLAG = gql`
  mutation RemoveCustomJobFlag($input: RemoveCustomJobFlagInput!) {
    removeCustomJobFlag(input: $input)
  }
`;

// Mutation to bulk update custom flags for a job
export const BULK_UPDATE_CUSTOM_JOB_FLAGS = gql`
  mutation BulkUpdateCustomJobFlags($input: BulkUpdateCustomJobFlagsInput!) {
    bulkUpdateCustomJobFlags(input: $input) {
      id
      jobId
      flagType
      flagValue
      flagColor
      isManual
      addedByUserId
      addedByUser {
        id
        name
      }
      sortOrder
      createdAt
      updatedAt
    }
  }
`;
